import getConfig from 'next/config';
import { encodeToBase64 } from '../helpers/base64';
var error = log => {
  var _ref = getConfig() || {},
    _ref$publicRuntimeCon = _ref.publicRuntimeConfig,
    publicRuntimeConfig = _ref$publicRuntimeCon === void 0 ? {} : _ref$publicRuntimeCon;
  var sendLogsToOpenSearch = (publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.NEXT_OPENSEARCH_LOGS) === 'true';
  try {
    logOnAppDynamics(log);
    sendLogsToOpenSearch && logOnOpenSearch(log);
  } catch (err) {
    console.log(err);
  }
};
var logOnAppDynamics = log => console.error(log);
var logOnOpenSearch = log => {
  var _publicRuntimeConfig$;
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var endpoint = (_publicRuntimeConfig$ = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.NEXT_PUBLIC_LOG_ENDPOINT) !== null && _publicRuntimeConfig$ !== void 0 ? _publicRuntimeConfig$ : '';
  if (endpoint) {
    var _navigator;
    (_navigator = navigator) === null || _navigator === void 0 || _navigator.sendBeacon(endpoint, encodeToBase64(JSON.stringify({
      log
    })));
  }
};
export default {
  error,
  logOnAppDynamics,
  logOnOpenSearch
};